import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { HistoryService } from '../../../services/history/history.service';
import { IoService } from '../../../services/io/io.service';
import { AuthorizationService } from '../../../services/authorization/authorization.service';
import { LocationService } from '../../../services/location/location.service';
import { ReportService } from '../../../services/report/report.service'
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { DialogButtonStyle, DialogConfig, DialogOption } from '../../shared/ui/dialog/dialog-options';
import { RfPipe } from 'src/app/pipes/rf/rf.pipe';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-detail-user',
  templateUrl: './detail-user.component.html',
  styleUrls: ['./detail-user.component.scss']
})
export class DetailUserComponent implements OnInit {

    documentId$: Observable<any>;
    documentId;
    showBackButton;
    resetRecentlySent = false;
    activeUserIsDeveloper;

    user;
    authenticatedUser;

    // True when the loaded record was a blank stub from the add flow (no identity
    // fields yet) — used to clean it up when the operator switches to an existing
    // record after a duplicate match.
    isNewRecord = false;

    states = [
      { name: 'Alabama', key: 'AL' },
      { name: 'Alaska', key: 'AK' },
      { name: 'Arizona', key: 'AZ' },
      { name: 'Arkansas', key: 'AR' },
      { name: 'California', key: 'CA' },
      { name: 'Colorado', key: 'CO' },
      { name: 'Connecticut', key: 'CT' },
      { name: 'Delaware', key: 'DE' },
      { name: 'Florida', key: 'FL' },
      { name: 'Georgia', key: 'GA' },
      { name: 'Hawaii', key: 'HI' },
      { name: 'Idaho', key: 'ID' },
      { name: 'Illinois', key: 'IL' },
      { name: 'Indiana', key: 'IN' },
      { name: 'Iowa', key: 'IA' },
      { name: 'Kansas', key: 'KS' },
      { name: 'Kentucky', key: 'KY' },
      { name: 'Louisiana', key: 'LA' },
      { name: 'Maine', key: 'ME' },
      { name: 'Maryland', key: 'MD' },
      { name: 'Massachusetts', key: 'MA' },
      { name: 'Michigan', key: 'MI' },
      { name: 'Minnesota', key: 'MN' },
      { name: 'Mississippi', key: 'MS' },
      { name: 'Missouri', key: 'MO' },
      { name: 'Montana', key: 'MT' },
      { name: 'Nebraska', key: 'NE' },
      { name: 'Nevada', key: 'NV' },
      { name: 'New Hampshire', key: 'NH' },
      { name: 'New Jersey', key: 'NJ' },
      { name: 'New Mexico', key: 'NM' },
      { name: 'New York', key: 'NY' },
      { name: 'North Carolina', key: 'NC' },
      { name: 'North Dakota', key: 'ND' },
      { name: 'Ohio', key: 'OH' },
      { name: 'Oklahoma', key: 'OK' },
      { name: 'Oregon', key: 'OR' },
      { name: 'Pennsylvania', key: 'PA' },
      { name: 'Rhode Island', key: 'RI' },
      { name: 'South Carolina', key: 'SC' },
      { name: 'South Dakota', key: 'SD' },
      { name: 'Tennessee', key: 'TN' },
      { name: 'Texas', key: 'TX' },
      { name: 'Utah', key: 'UT' },
      { name: 'Vermont', key: 'VT' },
      { name: 'Virginia', key: 'VA' },
      { name: 'Washington', key: 'WA' },
      { name: 'West Virginia', key: 'WV' },
      { name: 'Wisconsin', key: 'WI' },
      { name: 'Wyoming', key: 'WY' }
    ];

    private permissionsLoaded: Subscription;
    private detailDocumentSet: Subscription;

    constructor(
      private locationR: Location,
      private route: ActivatedRoute,
      private router: Router,
      private historyService: HistoryService,
      private authorizationService: AuthorizationService,
      private locationService: LocationService,
      private ioService: IoService,
      private reportService: ReportService,
      private dialog: MatDialog,
      private rf: RfPipe,
    ) { }

    ngOnInit() {
      this.documentId$ = this.route.paramMap.pipe(switchMap(params => of(params.get('documentId'))));
      this.documentId$.subscribe(documentId => {
        if (documentId) {
          this.documentId = documentId;
          this.init();
        }
      });

      if (this.historyService.getPreviousLinkDepth() > 3) {
        this.showBackButton = true;
      }
    }

    close() {
      this.reportService.closeDetailPanel(this.route);
    }

    back() {
      this.locationR.back();
    }

    init = async () => {
      console.log('detail-user init: ');

      this.user = null;

      this.authenticatedUser = this.authorizationService.getUser();

      // Get General User Data
      let user: any = await this.ioService.post('/user/getUser', {
        userId: this.documentId,
        getManagementAuthorization: true,
        getUserGroups: true,
        getClientConfig: true
      });

      if (!user.address) {
        user.address = [];
      }
  
      if (!user.note) {
        user.note = [];
      }

      if (user.telephone && user.telephone.length == 11) {
        // Remove the first character of the phone number
        user.telephone = user.telephone.substring(1);
      }

      this.isNewRecord = !user.firstName && !user.lastName && !user.email && !user.telephone;

      this.user = user;

      
      if ( this.user.passwordResetPending ) {
        const sentDate = new Date(this.user.passwordResetPending);
        this.resetRecentlySent = (new Date().getTime() - sentDate.getTime() < 60000);
      } else {
        this.resetRecentlySent = false;
      }


      // User Group Management
      // Find Which User Groups this user is allowed to manage







      this.user.activeLocation = null;

      // See if we can manage this user
      const authenticatedUser = this.authorizationService.getUser();
      this.user.managableLocations = [];

      for (const location of await this.locationService.getLocationsByType('retail')) {
        if (this.authorizationService.checkPermission('manageUsers', location._id)) {
          this.user.managableLocations.push(location);
          this.user.canManage = true;
        }
      }

      // Sort managable locations
      this.user.managableLocations.sort((a, b) => (a.name > b.name) ? 1 : (a.name === b.name) ? ((a.active > b.active) ? 1 : -1) : -1 );

      if (this.user.managableLocations.length > 0) {
        this.user.managableLocations.unshift({
          _id: (await this.locationService.getLocationsByType('retail')).map(location => {
            return location._id;
          }),
          name: "All Locations",
        });
      }

      this.user.managableLocations.unshift({
        _id: null,
        name: "General",
      });

      // Get other possible authorizations
      this.activeUserIsDeveloper = this.authorizationService.checkPermission('Developer', 'general');
      console.log('activeUserIsDeveloper: ', this.activeUserIsDeveloper);

      if (this.user.activeUserCanManage === false) {
        this.user.canManage = false;
      }

      console.log(this.user);
    }

    addAddress() {
      this.user.address.push({});
    }

    async saveChanges() {
      if (this.user.saving) {
        return;
      }

      this.user.saving = true;

      let user = JSON.parse(JSON.stringify(this.user));

      [
        'managableLocations',
        'customFields',
        'purchases',
        'clientConfig',
        'allUserGroups',
        'activeUserCanManage',
        'activeUserManageableUserGroupId',
        'addedBy',
        'timeAdded',
        'timeUpdated'
      ].forEach((key) => {
        if (user[key]) {
          delete user[key];
        }
      });

      try {
        let userUpdateResponse: any = await this.ioService.post('/user/updateUser', {
          user,
          locationId: this.locationService.getActiveLocationId()
        });

        this.reportService.loadReport(null);
        AppComponent.showSnack(userUpdateResponse.msg, '', 2000);
        this.close();

      } catch (err) {
        // Handle error such as duplicate profile

        if (err.error?.errorKey === 'duplicateUser') {
          this.promptDuplicateUser(err.error, user);
        } else {
          // Show genereal user update error
          AppComponent.showSnack(err.error.msg, '', 2000);
        }
      }

      this.user.saving = false;
    }

    // The server matched an existing person by email, telephone, or exact name.
    // Ask the operator whether this is the same person or a genuinely new one.
    // Name matches may be saved anyway; email/telephone duplicates cannot.
    promptDuplicateUser(duplicate, user) {
      const matchedName = duplicate.matchedName || 'An existing record';
      const matchType = duplicate.matchType || 'information';

      if (duplicate.matchedUserType === 'customer') {
        const options = matchType === 'name' ? ['Same Person', 'New Person', 'Cancel'] : ['Same Person', 'Cancel'];
        AppComponent.showMessage(
          'User Exists as Customer',
          `${matchedName} already exists as a customer with the same ${matchType}. Is this the same person? ` +
          'Choosing Same Person will convert the customer to a user and keep their purchase history.',
          options, true, options.length > 2 ? '760px' : '500px'
        ).afterClosed().subscribe((result: DialogOption) => {
          if (result?.value === 'Same Person') {
            this.convertCustomerToUser(duplicate.matchedUserId, user);
          } else if (result?.value === 'New Person') {
            this.retrySaveAllowingNameDuplicate(user);
          }
        });
      } else {
        const options = matchType === 'name' ? ['Open Existing', 'New Person', 'Cancel'] : ['Open Existing', 'Cancel'];
        AppComponent.showMessage(
          'User Already Exists',
          `${matchedName} already exists as a user with the same ${matchType}. Is this the same person?`,
          options, true, options.length > 2 ? '760px' : '500px'
        ).afterClosed().subscribe((result: DialogOption) => {
          if (result?.value === 'Open Existing') {
            this.openExistingUser(duplicate.matchedUserId);
          } else if (result?.value === 'New Person') {
            this.retrySaveAllowingNameDuplicate(user);
          }
        });
      }
    }

    async convertCustomerToUser(customerUserId, user) {
      try {
        const update = JSON.parse(JSON.stringify(user));
        delete update._id;

        await this.ioService.post('/user/convertUserType', {
          userId: customerUserId,
          stubUserId: this.isNewRecord ? this.documentId : null,
          user: update,
          allowNameDuplicate: true
        });

        AppComponent.showSnack('Customer converted to user.', '', 2000);
        this.reportService.loadReport(null);
        this.reportService.navigateWithinReport(['../../user/' + customerUserId], this.route);
      } catch (error) {
        AppComponent.showSnack(error.error?.msg || 'Error converting customer to user.', '', 2000);
      }
    }

    async retrySaveAllowingNameDuplicate(user) {
      try {
        const userUpdateResponse: any = await this.ioService.post('/user/updateUser', {
          user,
          locationId: this.locationService.getActiveLocationId(),
          allowNameDuplicate: true
        });

        this.reportService.loadReport(null);
        AppComponent.showSnack(userUpdateResponse.msg, '', 2000);
        this.close();
      } catch (err) {
        AppComponent.showSnack(err.error?.msg || 'Failed to save user.', '', 2000);
      }
    }

    async openExistingUser(matchedUserId) {
      // If this record is a blank stub from the add flow, deactivate it before
      // switching to the existing user so it does not linger in the report.
      if (this.isNewRecord) {
        try {
          await this.ioService.post('/user/updateUser', {
            user: { _id: this.documentId, active: false }
          });
        } catch (err) {
          console.log('Failed to deactivate blank user record', err);
        }
      }

      this.reportService.loadReport(null);
      this.reportService.navigateWithinReport(['../../user/' + matchedUserId], this.route);
    }

    async mergeUsers(sourceUserId, targetUserId, userUpdate = null) {
      try {
        await this.ioService.post('/user/mergeUsers', {
          sourceUserId,
          targetUserId,
          userUpdate
        });
        AppComponent.showSnack('User profiles merged successfully.', '', 2000);
      } catch (error) {
        AppComponent.showSnack('Error merging user profiles.', '', 2000);
      }
    }

    async saveChangesOld() {
      if (!this.user.saving) {
        this.user.saving = true;
        let duplicateUserField: string;
        if ( this.user.active ) {
          duplicateUserField = await this.checkForExistingUser();
        }
        let promptPromise = new Promise<boolean>((resolve, reject) => resolve(true));

        if ( duplicateUserField || !this.user.active ) {
          promptPromise = new Promise<boolean>((resolve, reject) => {
            const title = this.user.active ? 'User Already Exists' : 'Disable User';
            const message = this.user.active ? `A user already exists with this ${duplicateUserField}.`
                                             : 'Are you sure you want to disable this user?';
            const options = this.user.active ? null : ['Yes', 'Cancel'];
            const dialogRef = AppComponent.showMessage( title, message, options, false );
            dialogRef.afterClosed().subscribe( (result: DialogOption) => {
              if ( result.value === 'Yes' ) {
                resolve( true );
              } else {
                if (!this.user.active) {
                  this.user.active = true;
                }
                reject( false );
              }
            });
          });
        }
        promptPromise.then( (result) => {


          let user = JSON.parse(JSON.stringify(this.user));

          [
            'managableLocations',
            'customFields',
            'purchases',
          ].forEach((key) => {
            if (user[key]) {
              delete user[key];
            }
          });
          
          this.ioService.post('/user/updateUser', {
            user,
            locationId: this.locationService.getActiveLocationId()
          }).then(async (saveResponse: any) =>  {
            if ( !this.user.active ) {
              this.router.navigate(['/reports/users']);
              this.reportService.loadReport(null);
              AppComponent.showSnack('User Disabled.', '', 2000);
            } else {
              await this.init();
              this.user.updated = saveResponse.msg;
              this.reportService.loadReport(null);
              AppComponent.showSnack('Save Complete.', '', 2000);
            }
          }).catch((error: any) => {
            this.user.error = error.error.msg;
          });
        })
        .catch( (canceled) => {
          console.log( 'User update canceled.');
        })
        .finally(() => { this.user.saving = false; });
      }
    }

    async checkForExistingUser(): Promise<string> {
      return new Promise<string>(async (resolve, reject) => {
        await this.ioService.post('/user/findMatchingUsers', {
          user: this.user,
        })
        .then((res: any) => {
          resolve(res.duplicateField);
        })
        .catch((err) => {
          console.error('Failed to find matching users', err);
          resolve(null);
        });
      });
    }

    disableUser() {
      AppComponent.showMessage(
        'Disable User',
        'Are you sure you want to disable this user?',
        ['Yes', 'Cancel']
      ).afterClosed().subscribe((result: DialogOption) => {
        if (result.value === 'Yes') {
          this.user.active = false;
          this.saveChanges();
        }
      });
    }

    locationSelected = async () => {
      console.log('location selected!');

      // Get all Location based Permissions (not authorizations)
      const allPermissions: any = await this.ioService.post('/authorization/getPermissions');
      console.log('allPermissions: ', allPermissions);

      let permissionGroups: any = [];

      if (this.user.activeLocation._id) {
        permissionGroups = await this.ioService.post('/group/getPermissionGroups', {
          locationId: this.user.activeLocation._id
        });
      }

      console.log('permissionGroups: ', permissionGroups);
      this.user.permissionGroups = permissionGroups;

      const targetUserAuthorizations: any = await this.ioService.post('/authorization/getOtherUserAuthorizaitons', {
        userId: this.user._id,
        locationId: this.user.activeLocation._id
      });

      this.user.potentialPermissions = [];

      for (const permission of allPermissions) {
        if (this.authorizationService.checkPermission(permission.key, this.user.activeLocation._id, false)) {
          if (targetUserAuthorizations.indexOf(permission.key) !== -1) {
            permission.active = true;
          }
          this.user.potentialPermissions.push(permission);
        }
      }

      // Get all reports
      const reportCategories = this.reportService.getReportCategories();
      console.log('reportCategories: ', reportCategories);
      for (const category of reportCategories) {
        for (const categoryReport of category.options) {
          const permission = {
            name: 'Report: '+category.name+': '+categoryReport.name,
            key: 'report.'+categoryReport._id,
            active: null
          };

          if (this.authorizationService.checkPermission(permission.key, this.user.activeLocation._id, false)) {
            if (targetUserAuthorizations.indexOf(permission.key) != -1) {
              permission.active = true;
            }

            this.user.potentialPermissions.push(permission);
          }
        }
      }

      console.log('targetUserAuthorizations: ', targetUserAuthorizations);

      // Get all permissions the authenticated user has on this location
      // this.user.potentialPermissions = this.authorizationService.getLocationAuthorizations(this.user.activeLocation._id);

      // Get all permissions the target user on this location

      console.log(this.user);
    }

    sendPasswordReset = async () => {
      let userKey = this.user.email;

      if (Array.isArray(userKey)) {
        userKey = userKey[0];
      }

      const passwordResetResponse = await this.ioService.post('/authentication/requestPasswordReset', {
        userKey
      });

      this.user.passwordResetResponse = true;
      this.user.passwordResetPending = new Date();
    }

    sendPin = async () => {
      const pinResponse = await this.ioService.post('/authentication/setPin', {
        userId: this.user._id
      });

      this.user.pinResponse = pinResponse;
    }

    togglePermission = async (permission) => {
      console.log('togglePermission: ', permission);
      permission.updating = true;
      let action = 'grant';
      if (permission.active) {
        action = 'revoke';
      }

      await this.ioService.post('/authorization/'+action, {
        userId: this.documentId,
        key: permission.key,
        locationId: this.user.activeLocation._id
      });

      permission.updating = false;
      permission.active = !permission.active;
    }

    toggleUserGroup = async (userGroup) => {
      console.log('toggleUserGroup: ', userGroup);

      let allowMultipleUserGroups = false;

      if (this.user?.clientConfig?.settings?.allowMultipleUserGroupMembership) {
        allowMultipleUserGroups = true;
      }

      if (allowMultipleUserGroups) {
        if (this.user.userGroupId.indexOf(userGroup._id) === -1) {
          this.user.userGroupId.push(userGroup._id);
        } else {
          if (this.user.userGroupId.length > 1) {
            this.user.userGroupId = this.user.userGroupId.filter(item => item !== userGroup._id);
          }
        }
      } else {
        this.user.userGroupId = [userGroup._id];
      }

      console.log('this.user.userGroupId: ', this.user.userGroupId);
    }

    grantPermissionGroup = async (permissionGroup) => {
      console.log('grantPermissionGroup: ', permissionGroup);
      if (!permissionGroup.updating) {
        permissionGroup.updating = true;

        const grantGroupResponse: any = await this.ioService.post('/authorization/grantPermissionGroup', {
          userId: this.documentId,
          groupId: permissionGroup._id,
          locationId: this.user.activeLocation._id
        });

        permissionGroup.updating = false;

        await this.locationSelected();
      }
    }

    setApiKey = async () => {
      const apiKeyResponse: any = await this.ioService.post('/authentication/setApiKey', {
        userId: this.documentId,
        name: this.user.firstName+' '+this.user.lastName
      });

      alert(apiKeyResponse.apiKey);
    }

    startManageUserAuthorization = async () => {
      this.reportService.navigateWithinReport(['../../', 'user-authorization', this.documentId], this.route);
    }

}
